import { makeStyles, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    marginBottom: tokens.spacingVerticalL,
  },
  switchGroup: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    marginBottom: tokens.spacingVerticalL,
  },
  card: {
    width: "100%",
  },
  loaderHeight: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonContainer: {
    marginTop: "auto",
    display: "flex",
    justifyContent: "flex-end",
  },
  spanStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  groupHeader: {
    marginBottom: "12px",
    marginTop: "16px",
  },
  divider: {
    marginTop: "4px",
  },
  workHoursFilter: {
    display: "flex",
    alignItems: "center",
    columnGap: "0.5rem",
    rowGap: "0.5rem",
  },
  workHoursYearSelect: {
    width: "12rem"
  },
  workHourMonthEdit: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.5rem",
    marginBottom: "0.5rem"
  }
});

export default useStyles;